import {Heading, useTheme, View, Image, Text, Flex, Button, useAuthenticator, Divider} from "@aws-amplify/ui-react";
import {Link} from 'react-router-dom';
import coachingLogoWhite from '../assets/images/logo/logo-white.svg';
import './authenticatorOptions.css';
import Footer from "../components/NoAuth/Footer";

export const i18nTranslations = {
  it: {
    'Enter your Email': 'Inserisci la tua e-mail',
    'Enter your email': 'Inserisci la tua e-mail',
    'Enter your Password': 'Inserisci la tua password',
    'Reset Password': 'Reimposta la password',
    'We Texted You': 'Ti abbiamo inviato un\'e-mail',
    'Your passwords must match': 'Le password devono coincidere',
    'Invalid verification code provided, please try again.': "Il codice di verifica inserito non è valido. La preghiamo di riprovare",
  },
}

const options = {
  hideSignUp: true,
  loginMechanisms: ['email'],
  variation: 'default',
  components: {
    Header() {
      const {tokens} = useTheme();

      return (
        <View textAlign="center" padding={tokens.space.large}>
          <Image
            alt="Myedu logo"
            src={coachingLogoWhite}
          />
        </View>
      );
    },
    Footer() {
      return (
        <Footer/>
      );
    },

    SignIn: {
      Header() {
        const {tokens} = useTheme();

        return (
          <Heading
            padding={`${tokens.space.xl} ${tokens.space.xl} 0 ${tokens.space.xl}`}
            level={3}
          >
            Accedi al tuo account
          </Heading>
        );
      },

      Footer() {
        const {tokens} = useTheme();
        const {toResetPassword} = useAuthenticator();

        return (
          <Flex
            padding={`0 ${tokens.space.xl} ${tokens.space.xl} ${tokens.space.xl}`}
            direction="column"
            alignItems="center"
            justifyContent="center"
          >
            <Button
              fontWeight="normal"
              onClick={toResetPassword}
              size="small"
              variation="link"
            >
              Password dimenticata?
            </Button>
            <Divider size="small"/>
            <Text>
              Non hai un account?
              {' '}
              <Link
                to="https://coaching.myedu.it/#coaching_contact_form"
                style={{
                  color: '#9381ff',
                }}
              >
                Registrati
              </Link>
            </Text>
          </Flex>
        )
      }
    },
  },
}

export default options;
